export default __webpack_public_path__ + "static/Sourceforge-29346ccab9b89026fbd2102661360655.png";